module.exports = __webpack_public_path__ + "img/shuttlers-logo.bedb8ad7.svg";